import * as React from 'react';
import {FtDate} from "@/common/util/FtDate";
import {DateNav} from "@/component/view/DateNav";

interface Props {
    value: string;
    onChange: (value: string) => void;
}

export function YmNav(props: Props) {
    const { value, onChange } = props;

    return <DateNav
        todayLabel="이번달"
        onToday={() => onChange(new FtDate().ym())}
        onPrev={() => onChange(new FtDate(value).addMonth(-1).ym())}
        onNext={() => onChange(new FtDate(value).addMonth(1).ym())}
    />
}